<dx-tab-panel
  [dataSource]="tabs"
  [selectedIndex]="0"
  [loop]="false"
  [animationEnabled]="false"
  [showNavButtons]="false"
  [swipeEnabled]="false">
  <!-- Templates -->

  <div *dxTemplate="let data of 'details'">
    <dx-scroll-view>
      <app-document-type-details-tab [modelId]="modelId"></app-document-type-details-tab>
    </dx-scroll-view>
  </div>
</dx-tab-panel>
